/**
 * The stored staff token is exchanged for a new one once it is this old. The
 * server ends a session staff.jwt_ttl_seconds (30 days) after the token was
 * issued, so refreshing a day in keeps a rep who opens the app at least once in
 * any 30-day stretch signed in, without a request on every launch (#5489).
 */
export const STAFF_TOKEN_REFRESH_AFTER_SECONDS = 24 * 60 * 60;

function tokenClaims(token) {
  if (typeof token !== 'string') return null;
  const payload = token.split('.')[1];
  if (!payload) return null;
  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const claims = JSON.parse(atob(base64 + '='.repeat((4 - base64.length % 4) % 4)));
    return claims && typeof claims === 'object' ? claims : null;
  } catch (e) {
    return null;
  }
}

/**
 * @param {string} token a legacy staff JWT
 * @returns {number|null} its `iat` in seconds, or null when it cannot be read
 */
export function tokenIssuedAt(token) {
  const claims = tokenClaims(token);
  return claims && typeof claims.iat === 'number' ? claims.iat : null;
}

/**
 * An unreadable token is left alone: the server is the judge of whether it is
 * still good, and refreshing cannot fix a token it would refuse anyway.
 *
 * @param {string} token
 * @param {number} [nowSeconds]
 * @returns {boolean}
 */
export function staffTokenNeedsRefresh(token, nowSeconds = Date.now() / 1000) {
  // A switch-to token is minted `refreshable: false`, and its default lifetime
  // is the same day as the threshold below, so asking would only ever meet a
  // token at its expiry.
  if ((tokenClaims(token) || {}).refreshable === false) return false;
  const iat = tokenIssuedAt(token);
  return iat !== null && nowSeconds - iat >= STAFF_TOKEN_REFRESH_AFTER_SECONDS;
}
